import Image from 'next/image';
export const WoWLogo = ({ size = 96 }: { size?: number }) => {
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      className={`w-[${size}px] h-[${size}px] rounded flex items-center justify-center`}
    >
      <Image src="/WoW_icon.svg.png" width={size} height={size} alt="World of Warcraft" />
    </div>
  );
};
